$(document).ready(function () {
    $('.ui.dropdown')
        .dropdown()
        ;
})



$('body').on('click', '.js-reset', function(event) {
    event.preventDefault();
    $(this).parents('form').find('input').prop('checked', false);
    $(this).parents('form').find('button').prop('disabled', true);
})


$('.filter-form input').on('change', function() {
    var $check = $(this).parents('form').find('input:checked').length;
    console.log($check)
    
    if($check > 0) {
       $(this).parents('form').find('button').prop('disabled', false);
    }

    else {
        $(this).parents('form').find('button').prop('disabled', true);
    }
})


